(function () {
  'use strict';

  class ProductBadges extends HTMLElement {
    connectedCallback() {
      this.syncVisibility();
    }

    update(state) {
      if (!state) return;

      const available = state.available !== false;
      const soldOut = !available;
      const compareAtPrice = Number(state.compareAtPrice || 0);
      const price = Number(state.price || 0);
      const onSale = !soldOut && compareAtPrice > price;
      const purchaseOptionLabel = !soldOut ? String(state.purchaseOptionLabel || '').trim() : '';

      // New is set per product in Liquid; a sold out variant hides it.
      this.toggleBadge('new', !soldOut);
      this.toggleBadge('sold-out', soldOut);
      this.toggleBadge('sale', onSale);
      this.toggleBadge('purchase-option', Boolean(purchaseOptionLabel));

      const purchaseOptionBadge = this.querySelector('[data-product-badge="purchase-option"]');
      if (purchaseOptionBadge && purchaseOptionLabel) purchaseOptionBadge.textContent = purchaseOptionLabel;

      const saleBadge = this.querySelector('[data-product-badge="sale"]');
      if (saleBadge && onSale) {
        saleBadge.textContent = this.dataset.saleStyle === 'percentage'
          ? `-${Math.round(((compareAtPrice - price) * 100) / compareAtPrice)}%`
          : (this.dataset.saleText || 'Sale');
      }

      this.syncVisibility();
    }

    toggleBadge(type, visible) {
      const badge = this.querySelector(`[data-product-badge="${type}"]`);
      if (badge) badge.hidden = !visible;
    }

    syncVisibility() {
      this.hidden = !this.querySelector('[data-product-badge]:not([hidden])');
    }
  }

  if (!customElements.get('product-badges')) {
    customElements.define('product-badges', ProductBadges);
  }

  window.AxiomProductBadges = {
    update(root, state) {
      if (!root || !state) return;
      root.querySelectorAll('[data-product-badges]').forEach((badges) => {
        if (state.productId && badges.dataset.productId !== String(state.productId)) return;
        if (typeof badges.update === 'function') badges.update(state);
      });
    },
  };
})();
